import './LoginModal.scss';
import { Icon } from '../../icon/icon';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonLink from '../../common/ButtonLink/ButtonLink';
import { Form } from 'antd';
import InputComponent from '../../common/InputComponent/InputComponent';
import InputPasswordComponent from '../../common/InputPasswordComponent/InputPasswordComponent';
// import SignUpModal from '../SignUpModal/SignUpModal';
import useSignUpModal from '../SignUpModal/SignUpModal';
import useModalForgotPassword from '../ForgotPassword/ForgotPassword';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, oauthLogin } from '../../../store/actions/auth.action';
import { FacebookContext } from '../../../contexts/FacebookContext';
import { GoogleContext } from '../../../contexts/GoogleContext';
import { Divider } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { openMessageSuccess } from '../../common/Message/openMessageSuccess';
import { openMessageError } from '../../common/Message/openMessageError';
import { useTranslation } from 'react-i18next';
import { openModal } from '../../common/Modal/openModal';

// Module-level (not per-hook-instance) so every mounted useModalLogin/useModalAuth
// consumer shares the same guard; codeFB/codeGG come from contexts shared across
// the whole app, so a per-instance useRef let each mounted instance dispatch
// oauthLogin separately for the same code.
const processedOAuthCodes = new Set();

const useModalLogin = () => {
  const modal = useRef(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const codeFB = searchParams.get('code');

  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading } = useSelector(state => state.auth);
  const { login: loginFB } = useContext(FacebookContext);
  const { code: codeGG, login: loginGG } = useContext(GoogleContext);

  const { t } = useTranslation();

  const handleResponse = useCallback(
    action => {
      if (action.payload?.accessToken) {
        openMessageSuccess({ content: t('Successfully') });
        window.location.reload(true);
      } else if (action.error || action.meta?.requestStatus === 'rejected') {
        openMessageError({
          content: action.error?.message || t('Something went wrong'),
        });
      }
    },
    [codeFB, t]
  );

  const submit = values => {
    dispatch(login(values))
      .then(handleResponse)
      .catch(error => {
        openMessageError({
          content: error?.message || t('Something went wrong'),
        });
      });
  };

  // useEffect(() => {
  //   if (open) {
  //     lockMessage(); // 🛑 Chặn toàn bộ message error
  //   } else {
  //     unlockMessage(); // ✔️ Bật lại message khi modal đóng
  //   }
  // }, [open]);

  useEffect(() => {
    if (codeFB && !processedOAuthCodes.has(codeFB)) {
      processedOAuthCodes.add(codeFB);
      setSearchParams(prevParams => {
        prevParams.delete('material');
        return prevParams;
      });
      dispatch(oauthLogin({ oauthCode: codeFB, provider: 'facebook' }))
        .then(handleResponse)
        .catch(error => {
          openMessageError({
            content: error?.message || t('Something went wrong'),
          });
        });
      setSearchParams(prevParams => {
        prevParams.delete('code');
        prevParams.delete('state');
        return prevParams;
      });
    }
  }, [codeFB]);

  useEffect(() => {
    if (codeGG && !processedOAuthCodes.has(codeGG)) {
      processedOAuthCodes.add(codeGG);
      dispatch(oauthLogin({ oauthCode: codeGG, provider: 'google' }))
        .then(handleResponse)
        .catch(error => {
          openMessageError({
            content: error?.message || t('Something went wrong'),
          });
        });
    }
  }, [codeGG]);

  const openModalLogin = ({ onOpenSignUp, onOpenForgotPassword, onClose }) => {
    modal.current = openModal({
      content: (
        <>
          <Form layout="vertical" onFinish={submit}>
            <div className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <h2 className="!font-bold">{t('Login')}</h2>
            </div>
            <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
              <Form.Item
                label={'Email'}
                name={'email'}
                className="self-stretch"
              >
                <InputComponent size={'large'} placeholder={t('Enter Email')} />
              </Form.Item>
              <Form.Item
                label={t('Password')}
                name={'password'}
                className="self-stretch"
              >
                <InputPasswordComponent
                  size={'large'}
                  placeholder={t('Enter password')}
                  visible={false}
                />
              </Form.Item>
              <div className="flex justify-end items-center self-stretch">
                <ButtonLink
                  title={t('Forgot password')}
                  onClick={() => onOpenForgotPassword()}
                />
              </div>
            </div>
            <Form.Item className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <ButtonPrimaryLarge
                type={'submit'}
                title={t('Login')}
                className={'grow'}
                disabled={isLoading}
                loading={isLoading}
              />
            </Form.Item>
            <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
              <div className="flex justify-center items-center gap-16 self-stretch">
                <Divider
                  type="horizontal"
                  className="m-0 !p-0"
                  style={{ minWidth: '122px' }}
                />
                <span
                  className="text-body-small self-stretch text-nowrap"
                  style={{ color: '#818589' }}
                >
                  {t('Or login with')}
                </span>
                <Divider
                  type="horizontal"
                  className="m-0 !p-0"
                  style={{ minWidth: '122px' }}
                />
              </div>
              <div className="flex items-center justify-center gap-32">
                <div
                  className="w-[40px] h-[40px] flex"
                  style={{ cursor: 'pointer' }}
                  onClick={() => loginGG()}
                >
                  <Icon.ICGoogle />
                </div>
                <div
                  style={{ cursor: 'pointer' }}
                  className="w-[40px] h-[40px] flex button"
                  onClick={() => loginFB()}
                >
                  <Icon.ICFacebook />
                </div>
              </div>
            </div>
            <div className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
              <div className="flex justify-center items-center gap-8">
                <span className="text-body-medium">
                  {t("You don't have a Fitta account?")}
                </span>
                <ButtonLink
                  title={t('Register')}
                  style={{ color: '#258FD2' }}
                  onClick={() => onOpenSignUp()}
                />
              </div>
            </div>
          </Form>
        </>
      ),
      title: (
        <div className="flex p-40 pb-16 justify-center items-center self-stretch m-0">
          <a
            href={'/'}
            style={{
              backgroundImage: 'url(/assets/logo/new_logo_fitta.png)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: '32px',
              width: '120px',
              display: 'inline-block',
            }}
          ></a>
          <ButtonIconGhostMedium
            icon={<Icon.ICClose />}
            style={{ border: '1px solid #CFD1D2' }}
            className={'absolute top-24 right-24'}
            onClick={() => {
              modal.current?.destroy();
              onClose?.();
            }}
          />
        </div>
      ),
      footer: null,
      centered: true,
      closable: false,
      classNames: { content: '!p-0 !rounded-[8px]', header: '!m-0' },
      width: 480,
      styles: {
        mask: {
          background: 'rgba(221, 221, 221, 0.38)',
          backdropFilter: 'blur(8px)',
        },
      },
    });
  };
  return { openModalLogin };
};

// const LoginModal = ({ open, onClose }) => {
//   // const [openModalForgotPassword, setOpenModalForgotPassword] = useState(false);
//   // const [openModalSignUp, setOpenModalSignUp] = useState(false);
//   const { openModalSignUp } = useSignUpModal();
//   const { openModalForgotPassword } = useModalForgotPassword();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const codeFB = searchParams.get('code');

//   // const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { isLoading } = useSelector(state => state.auth);
//   const { login: loginFB } = useContext(FacebookContext);
//   const { code: codeGG, login: loginGG } = useContext(GoogleContext);

//   const { t } = useTranslation();

//   const handleResponse = useCallback(
//     action => {
//       if (action.payload?.accessToken) {
//         openMessageSuccess({ content: t('Successfully') });
//         window.location.reload(true);
//       }
//     },
//     [codeFB]
//   );

//   const submit = values => {
//     dispatch(login(values)).then(handleResponse);
//   };

//   // useEffect(() => {
//   //   if (open) {
//   //     lockMessage(); // 🛑 Chặn toàn bộ message error
//   //   } else {
//   //     unlockMessage(); // ✔️ Bật lại message khi modal đóng
//   //   }
//   // }, [open]);

//   useEffect(() => {
//     if (codeFB) {
//       setSearchParams(prevParams => {
//         prevParams.delete('material');
//         return prevParams;
//       });
//       dispatch(oauthLogin({ oauthCode: codeFB, provider: 'facebook' })).then(
//         handleResponse
//       );
//       setSearchParams(prevParams => {
//         prevParams.delete('code');
//         prevParams.delete('state');
//         return prevParams;
//       });
//     }
//   }, [codeFB]);

//   useEffect(() => {
//     if (codeGG)
//       dispatch(oauthLogin({ oauthCode: codeGG, provider: 'google' })).then(
//         handleResponse
//       );
//   }, [codeGG]);

//   return (
//     <>
//       <Modal
//         title={
//           <div className="flex p-40 pb-16 justify-center items-center self-stretch m-0">
//             <Link
//               to={'/'}
//               style={{
//                 backgroundImage: 'url(/assets/logo/new_logo_fitta.png)',
//                 backgroundRepeat: 'no-repeat',
//                 backgroundSize: 'contain',
//                 backgroundPosition: 'center',
//                 height: '32px',
//                 width: '120px',
//                 display: 'inline-block',
//               }}
//             ></Link>
//             <ButtonIconGhostMedium
//               icon={<Icon.ICClose />}
//               style={{ border: '1px solid #CFD1D2' }}
//               className={'absolute top-24 right-24'}
//               onClick={onClose}
//             />
//           </div>
//         }
//         closable={false}
//         classNames={{ content: '!p-0', header: 'm-0' }}
//         centered
//         width={480}
//         open={open}
//         onOk={() => {}}
//         footer={null}
//         onCancel={() => {}}
//       >
//         <Form layout="vertical" onFinish={submit}>
//           <div className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
//             <h2>{t('Login')}</h2>
//           </div>
//           <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
//             <Form.Item
//               label={'Email'}
//               name={'email'}
//               className="self-stretch"
//             >
//               <InputComponent size={'large'} placeholder={t('Enter Email')} />
//             </Form.Item>
//             <Form.Item
//               label={t('Password')}
//               name={'password'}
//               className="self-stretch"
//             >
//               <InputPasswordComponent
//                 size={'large'}
//                 placeholder={t('Enter password')}
//                 visible={false}
//               />
//             </Form.Item>
//             <div className="flex justify-end items-center self-stretch">
//               <ButtonLink
//                 title={t('Forgot password')}
//                 onClick={() => openModalForgotPassword()}
//               />
//             </div>
//           </div>
//           <Form.Item className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
//             <ButtonPrimaryLarge
//               type={'submit'}
//               title={t('Login')}
//               className={'grow'}
//               disabled={isLoading}
//               loading={isLoading}
//             />
//           </Form.Item>
//           <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
//             <div className="flex justify-center items-center gap-16 self-stretch">
//               <Divider
//                 type="horizontal"
//                 className="m-0 !p-0"
//                 style={{ minWidth: '122px' }}
//               />
//               <span
//                 className="text-body-small self-stretch text-nowrap"
//                 style={{ color: '#818589' }}
//               >
//                 {t('Or login with')}
//               </span>
//               <Divider
//                 type="horizontal"
//                 className="m-0 !p-0"
//                 style={{ minWidth: '122px' }}
//               />
//             </div>
//             <div className="flex items-center justify-center gap-32">
//               <div
//                 className="w-40 h-40 flex"
//                 style={{ cursor: 'pointer' }}
//                 onClick={() => loginGG()}
//               >
//                 <Icon.ICGoogle />
//               </div>
//               <div
//                 style={{ cursor: 'pointer' }}
//                 className="w-40 h-40 flex button"
//                 onClick={() => loginFB()}
//               >
//                 <Icon.ICFacebook />
//               </div>
//             </div>
//           </div>
//           <div className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
//             <div className="flex justify-center items-center gap-8">
//               <span className="text-body-medium">
//                 {t("You don't have a Fitta account?")}
//               </span>
//               <ButtonLink
//                 title={t('Register')}
//                 style={{ color: '#258FD2' }}
//                 onClick={() => openModalSignUp()}
//               />
//             </div>
//           </div>
//         </Form>
//       </Modal>
//       {/* <SignUpModal
//         open={openModalSignUp}
//         onClose={() => setOpenModalSignUp(false)}
//       /> */}
//       {/* <ForgotPassword
//         open={openModalForgotPassword}
//         onClose={() => setOpenModalForgotPassword(false)}
//       /> */}
//     </>
//   );
// };

export default useModalLogin;
